module.exports = __webpack_public_path__ + "img/bg3.5baa5c9d.png";